import styled from "styled-components";
import { BOX_SHADOW, PRIMARY, SECONDARY } from "../../const/colors";
import { mobile_normal, mobile_title } from "../../const/fonts";

export const ButtonClose = styled.button`
	border: none;
	background-color: #fff;
	color: ${SECONDARY};
	padding: 0.2rem 0.5rem;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
  margin-left: auto;

	svg {
		font-size: 2.5rem;
	}
	&:hover {
		background-color: #93291E;
		svg {
			color: #fff;
		}
	}
  @media screen and (max-width: 768px) {
    svg {
      font-size: 1.5rem;
    }
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${PRIMARY};
  position: relative;

  h2 {
    font-size: 1.2rem;
    padding: 0.7rem;
    margin: 0 auto;
    color: ${SECONDARY};
    font-weight: 800;
  }

  @media screen and (max-width: 768px) {
    h2 {
      font-size: ${mobile_title};
    }
  }
`;

export const ContainerModal = styled.div`
	background-color: ${SECONDARY};
	border: 1px solid ${PRIMARY};
	text-align: end;
`;

export const Button = styled.button`
  width: 80%;
	font-size: 1rem;
  font-weight: bold;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.7rem;
  margin: 0 auto;
	margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
  cursor: pointer;
  transition: all .3s ease-in-out;
  &:disabled {
    box-shadow: none;
    opacity: 0.8;
    cursor: initial;
	}
  &:hover:not(:disabled){
    background-color: #fff;
  }

	@media screen and (max-width: 2000px) {
		font-size: 0.9rem;
	}
	@media screen and (max-width: 1600px) {
		font-size: 0.8rem;
	}
	@media screen and (max-width: 768px) {
		font-size: ${mobile_normal};
	}
`;

export const InputContainer = styled.div`
	width: 100%;
  text-align: start;
	> input {
		border: 1px solid ${PRIMARY};
		outline: none;
		background-color: transparent;
		color: #fff;
		padding: 0.7rem 1rem;
		font-size: 0.9rem;
		width: 100%;
    margin-top: 0.25rem;
	}
	> input.error {
		border-color: red;
	}

	> label {
		padding: 0 0.2rem;
		color: #fff;
		font-size: 0.9rem;
		font-weight: bold;
	}

	@media screen and (max-width: 768px) {
		> label {
			font-size: ${mobile_normal};
		}
	}
	&:hover {
		input {
			border-color: #fff;
		}
	}
`;

export const Content = styled.div`
  padding: 2rem;
  text-align: center;
`;